import MovimentacoesView from "../../components/estoque/MovimentacoesView";

export default function MovimentacoesEstoque() {
  return <MovimentacoesView />;
}
